import { createContext, PropsWithChildren, useContext } from "react";
import { useIntercom } from "react-use-intercom";
import { useIntercomUnreadCount } from "~/providers/IntercomProvider";

type HelpContextType = {
	openIntercom: () => void;
	unreadCount: number;
};

const HelpContext = createContext<HelpContextType | undefined>(undefined);

const INTERCOM_APP_ID = import.meta.env.VITE_INTERCOM_APP_ID;

export const HelpProvider = (props: PropsWithChildren) => {
	const { children } = props;
	const unreadCount = useIntercomUnreadCount();

	if (!INTERCOM_APP_ID) {
		return (
			<HelpContext.Provider value={{ openIntercom: () => console.warn("Intercom not configured"), unreadCount: 0 }}>
				{children}
			</HelpContext.Provider>
		);
	}

	const { show } = useIntercom();

	return <HelpContext.Provider value={{ openIntercom: show, unreadCount }}>{children}</HelpContext.Provider>;
};

export const useHelp = () => {
	const context = useContext(HelpContext);
	if (!context) {
		throw new Error("useHelp must be used within a HelpProvider");
	}
	return context;
};
